'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = headInfo;

var _constants = require('redux/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    isShowSideMenu: false
}; /**
    * Created by maximus on 23.11.16.
    */
function headInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


    switch (action.type) {

        case _constants.HeadInfoConstants.SHOW_SIDEMENU:
            return (0, _extends3.default)({}, state, {
                isShowSideMenu: true
            });

        case _constants.HeadInfoConstants.HIDE_SIDEMENU:
            return (0, _extends3.default)({}, state, {
                isShowSideMenu: false
            });

        default:
            return state;
    }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/headInfo.js
// module id = 1901
// module chunks = 0